import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconPhoneProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconPhoneSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function OutlineSvg({ className, title }: IconPhoneSvgProps) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        role={title ? "img" : "presentation"}
        aria-label={title}
        className={className}
      >
        <path d="M16.37 20.25C15.9015 20.2564 15.4361 20.1715 15 20C12.5329 19.0408 10.2894 17.5844 8.40911 15.7213C6.52879 13.8582 5.05183 11.6282 4.07004 9.17C3.76197 8.53667 3.66661 7.82081 3.79814 7.12892C3.92967 6.43704 4.28106 5.8061 4.80004 5.33C5.20198 4.94475 5.62963 4.58726 6.08004 4.26C6.33275 4.05367 6.62732 3.90476 6.94331 3.82361C7.25931 3.74245 7.58917 3.73098 7.91004 3.79C8.26019 3.88174 8.5859 4.04932 8.86412 4.28088C9.14234 4.51244 9.36626 4.80232 9.52004 5.13C9.63004 5.32 9.72004 5.51 9.82004 5.7L10 6C10.301 6.59158 10.6348 7.16581 11 7.72C11.2435 8.04103 11.4016 8.41863 11.4593 8.81741C11.517 9.21619 11.4725 9.6231 11.33 10C11.2185 10.263 11.0519 10.499 10.8414 10.6922C10.631 10.8854 10.3816 11.0313 10.11 11.12C10.9757 12.1401 11.9441 13.0684 13 13.89C13.0812 13.6386 13.2113 13.4058 13.383 13.205C13.5546 13.0041 13.7643 12.8393 14 12.72C14.3405 12.5826 14.709 12.529 15.0744 12.5638C15.4399 12.5986 15.7917 12.7208 16.1 12.92L16.64 13.22C17.43 13.65 18.25 14.1 19.04 14.56C19.3328 14.7304 19.5871 14.9597 19.7867 15.2334C19.9864 15.5071 20.1271 15.8192 20.2 16.15C20.2631 16.4466 20.2628 16.7531 20.199 17.0496C20.1353 17.346 20.0095 17.6256 19.83 17.87C19.4703 18.3609 19.076 18.8254 18.65 19.26C18.3546 19.5679 18.0008 19.8139 17.6094 19.9839C17.218 20.1538 16.7967 20.2443 16.37 20.25ZM7.49004 5.25C7.30729 5.2659 7.13333 5.33548 6.99004 5.45C6.59082 5.76076 6.21016 6.09467 5.85004 6.45C5.54833 6.71589 5.34555 7.0761 5.27473 7.47196C5.20391 7.86783 5.26923 8.276 5.46004 8.63C6.3698 10.8959 7.73329 12.9519 9.46673 14.6716C11.2002 16.3913 13.2669 17.7383 15.54 18.63C15.8756 18.7994 16.2571 18.8549 16.627 18.7881C16.9968 18.7214 17.3349 18.536 17.59 18.26C17.9512 17.8805 18.2853 17.4762 18.59 17.05C18.6448 16.9745 18.6829 16.8882 18.7019 16.7968C18.7208 16.7054 18.7202 16.6111 18.7 16.52C18.6691 16.3936 18.6122 16.275 18.533 16.1717C18.4538 16.0684 18.3541 15.9827 18.24 15.92C17.46 15.46 16.66 15.02 15.88 14.6L15.35 14.3C15.1298 14.1526 14.86 14.0986 14.6 14.15C14.5131 14.2069 14.4394 14.2819 14.3842 14.3699C14.3289 14.458 14.2934 14.5569 14.28 14.66V14.78C14.2337 14.9605 14.1439 15.1269 14.0184 15.2646C13.8928 15.4023 13.7355 15.5072 13.56 15.57C13.3467 15.6412 13.119 15.6584 12.8973 15.62C12.6757 15.5816 12.467 15.4888 12.29 15.35C10.9558 14.3106 9.75056 13.1155 8.70004 11.79C8.55619 11.6177 8.4594 11.4111 8.4191 11.1903C8.37879 10.9695 8.39634 10.742 8.47004 10.53C8.53916 10.3412 8.65536 10.1733 8.80762 10.042C8.95988 9.91074 9.14315 9.82056 9.34004 9.78C9.58004 9.73 9.84004 9.64 9.92004 9.44C10 9.24 9.92004 8.93 9.65004 8.56C9.26712 7.94031 8.91988 7.29927 8.61004 6.64L8.48004 6.38L8.20004 5.84C8.08074 5.57408 7.86163 5.36575 7.59004 5.26L7.49004 5.25Z" />
      </svg>
    </>
  );
}

export default function IconPhone({
  theme = "black",
  style: _style = "filled",
  className,
  title,
}: IconPhoneProps) {
  const themeClassname = THEME_COLOR[theme];
  void _style;

  return (
    <OutlineSvg
      title={title}
      className={cn("icon-size-lg", className, themeClassname)}
    />
  );
}
